import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpHeaders,
  HttpResponse,
  HttpErrorResponse,
} from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, filter, switchMap, take, tap } from 'rxjs/operators';

//import { translateMessage } from '../helpers/translate-message';
import { AuthService } from '../services/auth.service';
import { GrandTypeEnum } from '../enums/grand-type-enum';
import { environment } from '../../environments/environment';
import { User } from '../models/user.model';

const ACCESS_TOKEN_KEY = 'accessToken'; // for Node.js Express back-end
const REFRESH_TOKEN_KEY = 'refreshToken'; // for Node.js Express back-end
const WEB_ACCESS_TOKEN_KEY = environment.AccessTokenKeyLabel; // session storage key name
const WEB_REFRESH_TOKEN_KEY = environment.RefreshTokenKeyLabel; // session storage key name
const PROJECT_ID = 'projectId';
//const UTC_TZ_DIFF_KEY = 'UTCDiff'; // session storage key name

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(
    null
  );

  constructor(private authenticationService: AuthService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<Object>> {
    let authReq = request;
    let accessToken = this.authenticationService.getToken(WEB_ACCESS_TOKEN_KEY);
    let refreshToken = this.authenticationService.getToken(
      WEB_REFRESH_TOKEN_KEY
    );

    if (accessToken && refreshToken) {
      authReq = this.addTokenHeaders(request, accessToken, refreshToken);
    }

    let user = this.authenticationService.CurrentUserValue;
    /*if (user && user.ImpersonatedBy && user.ImpersonatedBy._id) {
      authReq = this.appendBodyRequest(
        authReq,
        'ImpersonatedBy',
        user.ImpersonatedBy
      );
    }*/

    return next.handle(authReq).pipe(
      tap((evt) => {
        /*if (evt instanceof HttpResponse) {
         if (evt.body && evt.body.Message && evt.body.MsgCode) {
            let message = translateMessage(evt.body.MsgCode);
            if (!message) {
              evt.body.Message = message;
            }
          }
        }*/
      }),
      catchError((err) => {
        /*if (err instanceof HttpErrorResponse) {
          //console.log(err);
          if (err.error.Message && err.error.MsgCode) {
            let message = translateMessage(err.error.MsgCode);
            if (!message) {
              err.error.Message = message;
            }
          }
        }*/
        console.log(err);
        if (
          err instanceof HttpErrorResponse &&
          !authReq.url.includes('/accessToken') &&
          err.status === 401 &&
          err.error.data.invalid_access_token
        ) {
          return this.handle401Error(authReq, next);
        } else if (err instanceof HttpErrorResponse && err.status === 401) {
          // auto logout if 401 response returned from api
          this.autoLogout401Error();
        }
        return throwError(err);
      })
    );
  }

  //#region Userdefined functions
  private addTokenHeaders(
    request: HttpRequest<any>,
    accessToken: string,
    refreshToken: string
  ) {
    let loggedUser: User = this.authenticationService.CurrentUserValue;
    /* for Node.js Express back-end */
    const headers = new HttpHeaders({
      [ACCESS_TOKEN_KEY]: accessToken,
      [REFRESH_TOKEN_KEY]: refreshToken,
      [PROJECT_ID]: loggedUser.project_id,
      //['IsImpersonate']: isImpersonate,
      //[UTC_TZ_DIFF_KEY]: (-new Date().getTimezoneOffset()).toString(),
    });
    return request.clone({ headers });
  }

  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
    let refreshToken = this.authenticationService.getToken(
      WEB_REFRESH_TOKEN_KEY
    );
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);

      let credential = {
        refresh_token: refreshToken,
        grand_type: GrandTypeEnum.Token,
      };
      let userInfo = this.authenticationService.CurrentUserValue;
      let projectinfo = {
        project_id: userInfo.project_id,
        project_name: userInfo.project_name,
      };
      return this.authenticationService
        .authenticate(credential, projectinfo)
        .pipe(
          switchMap((response: any) => {
            this.isRefreshing = false;
            this.authenticationService.saveToken(response.data.token);
            this.refreshTokenSubject.next(response.data.token.access);

            return next.handle(
              this.addTokenHeaders(
                request,
                response.data.token.access,
                refreshToken ? refreshToken : ''
              )
            );
          }),
          catchError((err) => {
            this.isRefreshing = false;
            this.authenticationService.removeTokens();
            //this.socketService.signOut();
            return throwError(err);
          })
        );
    }
    return this.refreshTokenSubject.pipe(
      filter((token) => token !== null),
      take(1),
      switchMap((token) =>
        next.handle(
          this.addTokenHeaders(request, token, refreshToken ? refreshToken : '')
        )
      )
    );
  }

  private autoLogout401Error(): void {
    let userInfo = this.authenticationService.CurrentUserValue;
    if (userInfo && userInfo.id) {
      this.authenticationService.userLogout(userInfo.id.toString()).subscribe(
        (response) => {
          window.location.href = '/login';
        },
        (errorRes) => {
          console.error(errorRes);
          window.location.href = '/login';
        }
      );
    }
  }

  private appendBodyRequest(
    request: HttpRequest<any>,
    propertyNmae: string,
    propertyValue: any
  ) {
    if (request.method.toLowerCase() !== 'get') {
      if (request.body instanceof FormData) {
        request = request.clone({
          body: request.body.append(
            propertyNmae,
            JSON.stringify(propertyValue)
          ),
        });
      } else {
        const modifiedBody: any = {};
        modifiedBody[propertyNmae] = propertyValue;
        request = request.clone({
          body: { ...request.body, ...modifiedBody },
        });
      }
    }
    /*if (request.method.toLowerCase() === 'get') {
         request = request.clone({
          params: request.params.set(propertyNmae, propertyValue)
        });
      } */
    return request;
  }
  //#endregion
}
